import { useState } from 'react';
import { Lock, Footprints, FileText, Crown } from 'lucide-react';
import { Button } from './ui/button';
import PlanSelectionModal from './PlanSelectionModal';

/**
 * LockedFeatureCard
 * 
 * Card per mostrare feature bloccate e incentivare l'upgrade.
 * Usato per Registro passeggiate e Report Mensile nei piani non-Premium.
 */
export const LockedFeatureCard = ({ 
  icon: Icon,
  title,
  description,
  requiredPlan = 'premium',
  featureKey,
  userId,
  famigliaId,
  className = ''
}) => {
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  const planBadge = {
    'premium': { label: 'PREMIUM', color: 'bg-gradient-to-r from-orange-500 to-red-500' }
  };

  const badge = planBadge[requiredPlan] || planBadge.premium;

  return (
    <>
      <div className={`relative bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl p-6 overflow-hidden ${className}`}>
        {/* Blur overlay */}
        <div className="absolute inset-0 bg-white/60 backdrop-blur-[2px] z-10" />
        
        {/* Content */}
        <div className="relative z-20 flex flex-col items-center text-center">
          {/* Locked icon */}
          <div className="w-16 h-16 bg-gray-300/50 rounded-2xl flex items-center justify-center mb-4 relative">
            <Icon className="w-8 h-8 text-gray-400" />
            <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-gray-500 rounded-full flex items-center justify-center">
              <Lock className="w-3.5 h-3.5 text-white" />
            </div>
          </div>
          
          {/* Badge */}
          <span className={`inline-block px-3 py-1 ${badge.color} text-white text-xs font-bold rounded-full mb-3`}>
            {badge.label}
          </span>
          
          {/* Title & Description */}
          <h3 className="text-lg font-bold text-gray-700 mb-2">{title}</h3>
          <p className="text-sm text-gray-500 mb-4">{description}</p>
          
          {/* Upgrade button */}
          <Button 
            onClick={() => setShowUpgradeModal(true)}
            className={`${badge.color} text-white hover:opacity-90`}
          >
            <Crown className="w-4 h-4 mr-2" />
            Sblocca con {badge.label}
          </Button>
        </div>
      </div>
      
      <PlanSelectionModal
        isOpen={showUpgradeModal}
        onClose={() => setShowUpgradeModal(false)}
        currentPlan="standard"
        userId={userId}
        famigliaId={famigliaId}
        featureRequested={featureKey}
      />
    </>
  );
};

/**
 * LockedGPSCard
 * Pre-configured card for the walk log (Registro passeggiate) feature
 */
export const LockedGPSCard = ({ userId, famigliaId }) => (
  <LockedFeatureCard
    icon={Footprints}
    title="Registro passeggiate"
    description="Sai quando l'assistente esce a passeggio, da quanto è fuori e quanto è durata ogni passeggiata"
    requiredPlan="premium"
    featureKey="gps"
    userId={userId}
    famigliaId={famigliaId}
  />
);

/**
 * LockedMonthlyReportCard
 * Pre-configured card for Monthly Report feature
 */
export const LockedMonthlyReportCard = ({ userId, famigliaId }) => (
  <LockedFeatureCard
    icon={FileText}
    title="Report Mensile PDF"
    description="Genera un documento riepilogativo professionale per il medico"
    requiredPlan="premium"
    featureKey="report"
    userId={userId}
    famigliaId={famigliaId}
  />
);

export default LockedFeatureCard;
